import { EFltSsrType } from "@/enums/flightEnums.js";
import i18n from "@/fmt/i18n.js";

function formatSsrLabel(identifier, ssr) {
   // switch (identifier) {
   //    case "meal":
   //       return i18n.t("EFltSsrMealType_" + ssr.ssrSubType);
   //    case "seat":
   //       return i18n.t("EFltSsrSeat_" + ssr.ssrSubType);
   //    default:
   //       return ssr.ssrSubType;
   // }

   identifier;
   return ssr.ssrSubType;
}

export function formatCheckoutSsrs(legs, paxes) {
   const output = Object.fromEntries(
      Object.entries(legs).map(([legId, legData]) => [
         legId,
         {
            columns: generateColumns(legData.ssrs),
            paxes: PaxGenerator(paxes, legData),
         },
      ]),
   );

   return output;
}

function PaxGenerator(paxes, leg) {
   const paxList = [];
   let paxId = 1;

   const columns = generateColumns(leg.ssrs);
   const optionsByType = generateOptions(leg.ssrs);

   function createSsrs(paxId, segmentIndex, selectedPaxSegmentIndexes) {
      return Object.fromEntries(
         columns.map((col) => {
            const allOptions = optionsByType[col.identifier] || [];

            // Options'ı map'le ve eligibleKey'e göre filtrele
            const availableOptions = allOptions
               .map((option) => ({
                  ...option,
                  eligibleKey: option.eligiblePaxSegmentKeys?.[paxId]?.[segmentIndex]?.key || null,
               }))
               .filter((option) => option.eligibleKey && !option.eligiblePaxSegmentKeys?.[paxId]?.[segmentIndex]?.freeOfChargeConjunctedSegment);

            // Bu segment için conjuncted SSR var mı kontrol et
            const hasConjunctedOptions = allOptions.some((option) => {
               return option.eligiblePaxSegmentKeys?.[paxId]?.[segmentIndex]?.freeOfChargeConjunctedSegment === true;
            });

            // Bu segment, başka bir conjuncted segmentin master'ı mı?
            const isConjunctedMaster =
               !hasConjunctedOptions &&
               allOptions.some((option) => {
                  const paxKeys = option.eligiblePaxSegmentKeys?.[paxId];
                  if (!paxKeys) return false;
                  return Object.entries(paxKeys).some(([otherSegmentIndex, data]) => {
                     return Number(otherSegmentIndex) !== segmentIndex && data.freeOfChargeConjunctedSegment === true;
                  });
               });

            // Daha önce seçilmiş mi kontrol et (identifier bazında)
            const previousSelection = selectedPaxSegmentIndexes?.[col.identifier]?.[paxId]?.[segmentIndex] || null;
            const previousEligibleKey = previousSelection ? availableOptions.find((o) => o.ssrSubType === previousSelection.ssrSubType)?.eligibleKey || null : null;

            return [
               col.identifier,
               {
                  label: previousSelection ? previousSelection.label : null,
                  selected: !!previousSelection,
                  makingSelection: false,
                  name: previousSelection ? previousSelection.label : null,
                  price: previousSelection ? previousSelection.price : null,
                  eligibleKey: previousEligibleKey,
                  options: availableOptions,
                  isConjuncted: hasConjunctedOptions,
                  isConjunctedMaster: isConjunctedMaster,
                  isFreeConjuncted: previousSelection?.isFreeConjuncted || false,
                  inBasket: previousSelection?.inBasket || false,
               },
            ];
         }),
      );
   }

   function createSegments(paxId, selectedPaxSegmentIndexes) {
      return leg.segments.map((segment, index) => ({
         departureAirportCode: segment.departureAirportCode,
         arrivalAirportCode: segment.arrivalAirportCode,
         airlineCode: segment.marketingAirlineCode,
         ssrs: createSsrs(paxId, index + 1, selectedPaxSegmentIndexes),
      }));
   }

   // Her ssrType için selectedPaxSegmentIndexes'i birleştir
   // { ssrType_identifier: { paxId: { segmentIndex: ssrSubType } } }
   const selectedByType = generateSelected(leg.ssrs);

   Object.entries(paxes).forEach(([paxType, paxData]) => {
      for (let i = 0; i < paxData.count; i++) {
         paxList.push({
            id: paxId,
            // type: EFltPaxType[paxType],
            type: `${i18n.t("common_" + paxType.toLowerCase())} `,
            label: `${i18n.t("common_passenger")} ${paxId}`,
            segments: createSegments(paxId, selectedByType),
         });
         paxId++;
      }
   });

   return paxList;
}

function generateColumns(ssrs) {
   const seen = new Set();
   const columns = [];

   if (!ssrs) return columns;

   ssrs.forEach((ssr) => {
      if (!seen.has(ssr.ssrType)) {
         seen.add(ssr.ssrType);
         const label = EFltSsrType[ssr.ssrType];

         // Eğer label undefined ise skip et
         if (!label) {
            console.warn(`Unknown SSR type: ${ssr.ssrType}`);
            return;
         }

         columns.push({
            label,
            identifier: label.toLowerCase(),
            type: ssr.ssrType,
         });
      }
   });

   // cabin_bag'ı en başa taşı
   const cabinBagIndex = columns.findIndex((col) => col.identifier === "cabin_bag");
   if (cabinBagIndex > 0) {
      const cabinBag = columns.splice(cabinBagIndex, 1)[0];
      columns.unshift(cabinBag);
   }

   return columns;
}

// Tüm SSR'ların selectedPaxSegmentIndexes'ini identifier bazında ayırarak map oluştur
// { identifier: { paxId: { segmentIndex: { label, price, ssrSubType } } } }
function generateSelected(ssrs) {
   const merged = {};

   if (!ssrs) return merged;

   ssrs.forEach((ssr) => {
      const eligibleKeys = ssr.eligiblePaxSegmentKeys;
      if (!eligibleKeys || Object.keys(eligibleKeys).length === 0) return;

      const label = EFltSsrType[ssr.ssrType];
      const identifier = label.toLowerCase();

      if (!merged[identifier]) merged[identifier] = {};

      Object.entries(eligibleKeys).forEach(([paxId, segmentIndexes]) => {
         if (!merged[identifier][paxId]) merged[identifier][paxId] = {};

         // Bu pax için gerçekten selected olan segment var mı?
         const hasRealSelection = Object.values(segmentIndexes).some((s) => s.selected && !s.freeOfChargeConjunctedSegment);

         Object.entries(segmentIndexes).forEach(([segmentIndex, segmentData]) => {
            if (!segmentData.selected && !segmentData.freeOfChargeConjunctedSegment) return;
            // freeOfChargeConjuncted ise sadece gerçek seçim varsa ekle
            if (segmentData.freeOfChargeConjunctedSegment && !hasRealSelection) return;
            merged[identifier][paxId][segmentIndex] = {
               label: formatSsrLabel(identifier, ssr),
               price: ssr.price?.parsedValue ?? ssr.price,
               ssrSubType: ssr.ssrSubType,
               isFreeConjuncted: segmentData.freeOfChargeConjunctedSegment,
               inBasket: true,
            };
         });
      });
   });

   return merged;
}

// Aynı ssrType'a sahip SSR items'ı grupla, her grup için options array oluştur
function generateOptions(ssrs) {
   const grouped = {};

   if (!ssrs) return grouped;

   // Önce aynı ssrSubType'a sahip SSR'ları birleştir (conjuncted segmentler için)
   // NOT: Koltuklar (seat) için value kullan, çünkü her koltuk benzersiz olmalı
   const mergedSsrs = {};
   ssrs.forEach((ssr) => {
      const label = EFltSsrType[ssr.ssrType];
      const identifier = label.toLowerCase();

      // Koltuklar için value bazlı key kullan, diğerleri için ssrSubType
      const uniqueKey = identifier === "seat" ? `${ssr.ssrType}_${ssr.value}` : `${ssr.ssrType}_${ssr.ssrSubType}`;

      if (!mergedSsrs[uniqueKey]) {
         mergedSsrs[uniqueKey] = { ...ssr, eligiblePaxSegmentKeys: {} };
      }

      // eligiblePaxSegmentKeys'leri birleştir
      Object.entries(ssr.eligiblePaxSegmentKeys || {}).forEach(([paxId, segments]) => {
         if (!mergedSsrs[uniqueKey].eligiblePaxSegmentKeys[paxId]) {
            mergedSsrs[uniqueKey].eligiblePaxSegmentKeys[paxId] = {};
         }
         Object.assign(mergedSsrs[uniqueKey].eligiblePaxSegmentKeys[paxId], segments);
      });
   });

   Object.values(mergedSsrs).forEach((ssr) => {
      const label = EFltSsrType[ssr.ssrType];
      const identifier = label.toLowerCase();

      if (!grouped[identifier]) {
         grouped[identifier] = [];
      }

      grouped[identifier].push({
         label: formatSsrLabel(identifier, ssr),
         value: ssr.value,
         unit: ssr.unit,
         price: ssr.price,
         currency: ssr.currency,
         ssrSubType: ssr.ssrSubType,
         eligiblePaxSegmentKeys: ssr.eligiblePaxSegmentKeys,
      });
   });

   // Seat sıralama algoritması
   if (grouped["seat"]) {
      grouped["seat"].sort((a, b) => {
         const matchA = a.value?.match(/^(\d+)([A-Z])$/);
         const matchB = b.value?.match(/^(\d+)([A-Z])$/);

         if (!matchA || !matchB) return 0;

         const numA = parseInt(matchA[1], 10);
         const numB = parseInt(matchB[1], 10);
         const letterA = matchA[2];
         const letterB = matchB[2];

         if (numA !== numB) {
            return numA - numB;
         }

         return letterA.localeCompare(letterB);
      });
   }

   return grouped;
}
